import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Collapse } from "reactstrap"
import { getMonitorTotalExpireReceiptsCount } from "store/monitor-expire-receipts/monitor-expire-action"
import { getMonitorStockOutCount } from "store/monitor-stock-out/monitor-stockout-action"
import ProtectedMenuItem from "components/Common/ProtectedMenuItem"
import { PERMISSIONS } from "utils/permissionConfig"

const MonitorNavbar = props => {
  const [expireList, setExpireList] = useState(false)
  const [items, setItems] = useState(false)
  const [systemSetup, setSystemSetup] = useState(false)
  const [report, setReport] = useState(false)

  const dispatch = useDispatch()
  const totalExpireCount = useSelector(
    state => state.monitorExpireReceipts.count
  )

  const totalStockOut = useSelector(state => state.monitorStockout.count)

  useEffect(() => {
    dispatch(getMonitorTotalExpireReceiptsCount())
    dispatch(getMonitorStockOutCount())
  }, [])

  return (
    <Collapse
      isOpen={props.leftMenu}
      className="navbar-collapse"
      id="topnav-menu-content"
    >
      <ul className="navbar-nav">
        <li className="nav-item ">
          <Link className="nav-link " to="/monitor-receipts">
            <i className="bx bx-home-circle me-2"></i>
            Receipts ( In )
          </Link>
        </li>
        <li className="nav-item ">
          <Link className="nav-link " to="/monitor-distributions">
            <i className="bx bx-home-circle me-2"></i>
            Distributions ( Out )
          </Link>
        </li>
        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle arrow-none"
            onClick={e => {
              e.preventDefault()
              setExpireList(!expireList)
            }}
            to="#"
            style={
              totalExpireCount?.countPerMonth > 0 ||
              totalExpireCount?.countPerYear > 0
                ? { color: "red" }
                : {}
            }
          >
            <i className="mdi mdi-order-bool-descending me-2"></i>
            Expire Lists{props.menuOpen}
            <div className="arrow-down"></div>
          </Link>
          <div className={"dropdown-menu"}>
            <Link to="/monitor-exipre-receipts" className="dropdown-item">
              Expire List / 6 Month &nbsp;
              <span className="text-danger" style={{ fontSize: 11 }}>
                ( {totalExpireCount?.countPerMonth} )
              </span>
            </Link>

            <Link
              to="/monitor-exipre-receipts-based-12"
              className="dropdown-item"
            >
              Expire List / 12 Month &nbsp;
              <span className="text-danger" style={{ fontSize: 11 }}>
                ( {totalExpireCount?.countPerYear} )
              </span>
            </Link>
          </div>
        </li>
        <li className="nav-item ">
          <Link className="nav-link " to="/monitor-consumptions-reports">
            <i className="bx bx-home-circle me-2"></i>
            Consumptions
          </Link>
        </li>
        <li className="nav-item ">
          <Link className="nav-link " to="/monitor-stock-out">
            <i className="bx bx-home-circle me-2"></i>
            Stock Out &nbsp;
            <span className="text-danger" style={{ fontSize: 11 }}>
              ( {totalStockOut} )
            </span>
          </Link>
        </li>
        <li className="nav-item ">
          <Link className="nav-link " to="/dashboard">
            <i className="bx bx-home-circle me-2"></i>
            Dashboard
          </Link>
        </li>

        <ProtectedMenuItem permission={[PERMISSIONS.SHOW_WAREHOUSE, PERMISSIONS.SHOW_PROJECT, PERMISSIONS.SHOW_PROVIDER, PERMISSIONS.SHOW_PROVINCE, PERMISSIONS.SHOW_CURRENCY, PERMISSIONS.SHOW_FACILITY, PERMISSIONS.SHOW_IP]} permissionLogic="any">
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setSystemSetup(!systemSetup)
              }}
              to="#"
            >
              <i className="mdi mdi-cog me-2"></i>
              System Setup {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_WAREHOUSE}>
                <Link to="/warehouse" className="dropdown-item">
                  <i className="mdi mdi-warehouse me-2"></i>
                  Warehouse
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROJECT}>
                <Link to="/projects" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Project
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVIDER}>
                <Link to="/providers" className="dropdown-item">
                  <i className="mdi mdi-order-bool-descending me-2"></i>
                  Providers
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_PROVINCE}>
                <Link to="/provinces" className="dropdown-item">
                  <i className="mdi mdi-google-maps me-2"></i>
                  Province
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_CURRENCY}>
                <Link to="/currencies" className="dropdown-item">
                  <i className="mdi mdi-currency-usd me-2"></i>
                  Currency
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_FACILITY}>
                <Link to="/facilities" className="dropdown-item">
                  <i className="mdi mdi-home me-2"></i>
                  Facilities
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_IP}>
                <Link to="/ips" className="dropdown-item">
                  <i className="mdi mdi-account-group me-2"></i>
                  IPs
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <ProtectedMenuItem permission={[PERMISSIONS.SHOW_ITEM_CATEGORY, PERMISSIONS.SHOW_ITEM]} permissionLogic="any">
          <li className="nav-item dropdown">
            <Link
              className="nav-link dropdown-toggle arrow-none"
              onClick={e => {
                e.preventDefault()
                setItems(!items)
              }}
              to="#"
            >
              <i className="mdi mdi-order-bool-descending me-2"></i>
              Items {props.menuOpen}
              <div className="arrow-down"></div>
            </Link>
            <div className={"dropdown-menu"}>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM_CATEGORY}>
                <Link to="/item-categories" className="dropdown-item">
                  Item Category
                </Link>
              </ProtectedMenuItem>
              <ProtectedMenuItem permission={PERMISSIONS.SHOW_ITEM}>
                <Link to="/items" className="dropdown-item">
                  Item
                </Link>
              </ProtectedMenuItem>
            </div>
          </li>
        </ProtectedMenuItem>

        <li className="nav-item dropdown">
          <Link
            className="nav-link dropdown-toggle arrow-none"
            onClick={e => {
              e.preventDefault()
              setReport(!report)
            }}
            to="#"
          >
            <i className="mdi mdi-order-bool-descending me-2"></i>
            Reports {props.menuOpen}
            <div className="arrow-down"></div>
          </Link>
          <div className={"dropdown-menu"}>
            <Link to="/monitor-transactions" className="dropdown-item">
              All Transactions ( In / Out )
            </Link>
            <Link to="/monitor-receipt-reports" className="dropdown-item">
              Receipts ( In )
            </Link>
            <Link to="/monitor-distribution-reports" className="dropdown-item">
              Distributions ( Out )
            </Link>
            <Link
              to="/monitor-ip-distribution-reports"
              className="dropdown-item"
            >
              IP Distributions ( Out )
            </Link>
            <Link to="/monitor-inventory-reports" className="dropdown-item">
              Inventory
            </Link>
            <Link
              to="/monitor-consumptions-reports-two"
              className="dropdown-item"
            >
              Consumptions Report
            </Link>
            <Link
              to="/monitor-receipt-health-reports"
              className="dropdown-item"
            >
              Receipt Health ( In )
            </Link>
            <Link to="/monitor-quantification-report" className="dropdown-item">
              Quantification Report
            </Link>
            <Link
              to="/monitor-quantification-report-based-organization"
              className="dropdown-item"
            >
              Quantification Based Organization Report
            </Link>
          </div>
        </li>
      </ul>
    </Collapse>
  )
}

export default MonitorNavbar
